import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';
import EzPopunder from 'components/util/ez-popunder';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class PartnerPopupController extends EzController {
  connect() {
    this.impactRadiusUrl = this.element.getAttribute('data-impact-radius-url');
  }

  maybePagination() {
    this.mode = 'pagination';

    if (!this.recentlySeenPopup()) {
      triggerCustomEvent(events.partner.pagination_popup, {});
      this.openPopup();
    }
  }

  openPopup() {
    Cookies.set('sstkSearchPU', { lastSeen: Date.now() });

    // TODO: implement skip-sstk-popup, or is that a failed split test?
    const popup = new EzPopunder();

    popup.open(this.partnerUrl());
  }

  recentlySeenPopup() {
    const cookie = Cookies.getJSON('sstkSearchPU');

    if (!cookie) return false;

    const thirtyMinutes = 1000 * 60 * 30;
    const threshold = Date.now() - thirtyMinutes;

    return cookie.lastSeen > threshold;
  }

  isLucky() {
    // 3. The lucky number is 3.
    return this.randomNumber() === 3;
  }

  randomNumber() {
    // return a random number between 1 and 5, inclusively
    return Math.floor(Math.random() * 5) + 1;
  }

  get searchTerm() {
    const searchForm = document.querySelector("[data-controller~='search-form']");

    if (!searchForm) {
      return null;
    }

    if (this.mode === 'pagination') {
      return searchForm.getAttribute('data-search-term').replace(/-/g, ' ');
    }

    const searchInput = searchForm.querySelector('input[name=search]');
    if (searchInput) {
      return searchInput.value;
    }

    return null;
  }

  partnerUrl() {
    switch (this.mode) {
      case 'search':
        return this.makePopupUrl(encodeURIComponent(this.subId1()));
      case 'pagination':
        return this.makePopupUrl('pagination');
      default:
        return null;
    }
  }

  makePopupUrl(subId1) {
    const params = {
      u: encodeURIComponent(this.destinationUrl),
      sharedid: window.location.hostname,
      subId1,
      subId2: this.subId2(),
      subId3: this.subId3(),
      adtype: this.adType,
      adplacement: 'POP',
    };

    return `${this.impactRadiusUrl}?${
      Object.keys(params).map((key) => `${key}=${params[key]}`).join('&')}`;
  }

  subId1() {
    if (this.mode === 'pagination') {
      return 'pagination';
    }

    const { classList } = document.body;

    if (classList.contains('home-home_vectors')) {
      return 'SearchPopHome';
    }

    if (classList.contains('resources-show')) {
      return 'SearchPopShow';
    }

    if (classList.contains('searches-show')) {
      return 'SearchPopSearch';
    }

    return 'SearchPopOther';
  }

  subId2() {
    return document.body.getAttribute('data-pageview-guid');
  }

  subId3() {
    return `${this.searchTerm}_null_${this.mode}pop`;
  }

  get destinationUrl() {
    return this.element.getAttribute('data-destination-url').replace(/{{search_term}}/g, this.searchTerm);
  }

  get adType() {
    return Cookies.get('content_type') || 'vector';
  }

  isMobile() {
    return document.body.classList.contains('is-mobile');
  }
}
